export default __webpack_public_path__ + "static/media/coldchain.13f55f5e.svg";